// extracted by mini-css-extract-plugin
module.exports = {"badge":"sh","isRental":"si","badgeWrapper":"sj","hide":"sk","roundedBadge":"sl","gridBadge":"sm"};